export const MODULE_ROUTE = {
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  CHANGE_PASSWORD: "/change-password",
  PROFILE: "/profile",
  DASHBOARD: "/dashboard",
  BRANCH: "/branch",
  EMPLOYEE: "/employee",
  COMPUTERS: "/remote-machine",
  SETTING_WORKSTATION_PAGE: "/setting-workstation",
  PACKAGE_DATA: "/list-package-data",
  HISTORY_TRANSACTION: "/history-transaction",
  LIST_DEPARTMENT: "/department",
  WORKSTATION_AREA: "/workstation-area",
  DETAIL_DEPARTMENT: "/department-detail",
  LIST_ACCOUNT_CUSTOMER: "/list-account",
  ID_VERIFICATION: "/id-verification",
  RECHARGE_PACKAGE: "/recharge-package",
  WAREHOUSING: "/warehousing",
  INCOME_EXPENDITURE: "/income-expenditure",
  DETAIL_INCOME_EXPENDITURE: "/detail-income-expenditure",
  DETAIL_WAREHOUSING: "/detail-warehousing",
  DETAIL_RECHARGE_PACKAGE: "/detail-recharge-package",
  MANAGEMENT_GAME: "/game",
  MANAGEMENT_NEWFEED: "/newfeed",
  CATEGORY_GAME: "/category-game",
  BOOKING_MANAGEMENT: "/booking",
  ORDER: "/order",
  CATEGORY: "/list-of-categories",
  RECHARGE_HISTORY: "/recharge-history",
  BANK_TRANSFER_QUEUE: "/bank-transfers",
  SETTINGS: "/setting",
  INCOME_AND_EXPENDITURE: "/income-and-expenditure",
  CHAT: "/chat",
  CATEGORIES_RECEIPT_PAGE: "/categories-receipt",
  MATERIAL_AND_PRODUCT: "/material-and-product",
  INVENTORY_WAREHOUSE: "/inventory-warehouse",
  TIMEKEEPING_USER_PAGE: "/timekeeping-user",
  SHIFT_SESSION: "/shift-session",
  SHIFT_PAGE: "/shift",
  PROMOTION_COMBO_PAGE: "/promotion-combo",
  PROMOTION_TICKET_PAGE: "/promotion-ticket",
  PROMOTION_CUSTOMER_DISCOUNT_PAGE: "/promotion-customer-discount",
  PROMOTION_AREA_DISCOUNT_PAGE: "/promotion-area-discount",
  PROMOTION_RECHARGE_PACKAGE_MILESTONES_PAGE: "/promotion-recharge-package-milestones",
  PROMOTION_MEMBERSHIP_LEVEL_PAGE: "/promotion-membership-level",
  PROMOTION_BUY_HISTORY: "/promotion-buy-history",
  EMPLOYEE_NOTIFICATION_HISTORY: "/employee-notification-history",
  PRINTER_PAGE: "/printer",
  BACKGROUND_LOGIN: "/background-login",
  MANAGEMENT_SERVICE: "/",
  PRODUCT: "/product",
  API_KEY: "/api-key",
  TIMELINE: "/timeline",
  // Promotion Masters (New)
  PROMOTION_MASTERS: "/promotion-masters",
  PROMOTION_MASTERS_CREATE: "/promotion-masters/create",
  PROMOTION_MASTERS_EDIT: "/promotion-masters/edit/:id",
  PROMOTION_MASTERS_DETAIL: "/promotion-masters/:id",
  // Vouchers (New)
  VOUCHER_TEMPLATES: "/voucher-templates",
  VOUCHER_TEMPLATES_CREATE: "/voucher-templates/create",
  VOUCHER_TEMPLATES_EDIT: "/voucher-templates/edit/:id",
  VOUCHERS: "/vouchers",
  // Promotion Reports
  PROMOTION_REPORTS: "/promotion-reports",
  // Reports Dashboard
  REPORTS_DASHBOARD: "/reports",
  REPORT_REVENUE: "/reports/revenue",
  REPORT_COMPUTER_PERFORMANCE: "/reports/computer-performance",
  REPORT_WORKSTATION_STATUS: "/reports/workstation-status",
  REPORT_PRODUCT_SALES: "/reports/product-sales",
  REPORT_SHIFT_CLOSE: "/reports/shift-close",
  PROMOTION_CREDIT_PAGE: "/promotion-credit",
  PLAY_TIME_PACKAGE: "/play-time-package",
  PLAY_TIME_TRANSACTIONS: "/play-time-transactions",
  ZALO_OA_INBOX: "/zalo-oa/inbox",
};
